export const run = (classHolder, modalWidth = false) => {
    const elementList = document.querySelectorAll(`.${classHolder}`)

    if (classHolder != 'k-tooltip-wrapper') { //k-s-input
        for (let index = 0; index < elementList.length; index++) {
            const element = elementList[index];
            const errorInput = element.previousElementSibling.children[0];
            if (errorInput.tagName.toLowerCase() == 'input') {
                errorInput.addEventListener('focusin', calculateDirection, true);
                errorInput.addEventListener('focus', calculateDirection, true);
                errorInput.addEventListener('keyup', calculateDirection, true);
            }
        }
    } else { //newTooltip
        elementList.forEach(wrapper => {
            let modal = wrapper.querySelector('.k-tooltip-modal');

            //DOMloaded
            calculateDirection(wrapper);
            window.addEventListener('resize', () => calculateDirection(wrapper));
            wrapper.addEventListener('mouseover', () => calculateDirection(wrapper));

            if (modal) {
                !modalWidth ? modalWidth = 585 : '';
                let modalInstance = $kl.Modal.init(modal, {maxElmntWidth: modalWidth, scrollable: false});
                let openButton = wrapper.querySelector('.k-tooltip-icon');
                let closeButton = modal.querySelector('.k-modal-content-close');

                openButton.addEventListener('click', () => {
                    modalInstance.open();
                });

                closeButton.addEventListener('click', () => {
                    modalInstance.close();
                });
            }
        });
    }
}

export const remove = (classHolder) => {
    const elementList = document.querySelectorAll(`.${classHolder}`)

    if (classHolder != 'k-tooltip-wrapper') { //k-s-input
        for (let index = 0; index < elementList.length; index++) {
            const element = elementList[index];
            const errorInput = element.previousElementSibling.children[0];
            if (errorInput.tagName.toLowerCase() == 'input') {
                errorInput.removeEventListener('focusin', calculateDirection, true);
                errorInput.removeEventListener('focus', calculateDirection, true);
                errorInput.removeEventListener('keyup', calculateDirection, true);
            }
        }
    } else { //newTooltip
        elementList.forEach(wrapper => {
            // wrapper.removeEventListener('click', () => calculateDirection(wrapper));
            window.removeEventListener('resize', () => calculateDirection(wrapper));
            wrapper.removeEventListener('mouseover', () => calculateDirection(wrapper));
        });
    }
}

function calculateDirection (data) {
    if(data.type == 'keyup' && data.keyCode != 13) {
        return;
    }

    if (data.target){//k-s-input
        const element = data.target;
        const elementParent = element.parentElement;
        const elementError = elementParent.nextElementSibling.classList.contains('k-s-error') ? elementParent.nextElementSibling : null;
        let xPosition = elementParent.parentElement.offsetLeft;
        let maxWidthAllowed = window.innerWidth - 20;
        elementError.style.maxWidth = '';

        if (elementError.offsetWidth >= maxWidthAllowed) {
            elementError.style.maxWidth = 'calc(95vw - ' + (xPosition + 20) + 'px)';
        } else if ((elementError.offsetWidth + xPosition) > maxWidthAllowed) {
            if(!elementError.classList.contains('k-right-aligned-error')){
                elementError.classList.add('k-right-aligned-error')
            }
        } else {
            if(elementError.classList.contains('k-right-aligned-error')){
                elementError.classList.remove('k-right-aligned-error')
            }
        }
    } else {//newTooltip
        let wrapper = data;
        let xPosition = wrapper.offsetLeft;
        let maxWidthAllowed = window.innerWidth - 20;
        let tooltip = wrapper.querySelector('.k-tooltip-content');

        if (tooltip.offsetWidth >= maxWidthAllowed) {
            tooltip.style.maxWidth = 'calc(95vw - ' + (xPosition + 20) + 'px)';
        } else if ((tooltip.offsetWidth + xPosition) > maxWidthAllowed) {
            if(!tooltip.classList.contains('k-right-aligned-error')){
                tooltip.classList.add('k-right-aligned-error')
            }
        } else {
            if(tooltip.classList.contains('k-right-aligned-error')){
                tooltip.classList.remove('k-right-aligned-error')
            }
        }
    }
}